import React, { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber';
import { AutoComplete } from 'primereact/autocomplete';
import { InputTextarea } from 'primereact/inputtextarea';

import { useAuth } from 'src/contexts/auth';
import { useData } from 'src/contexts/data';
import LoadingScreen from 'src/components/LoadingScreen';

import { useListCreditorsController } from 'src/controllers/Creditor/ListCreditorsController';
import { useFormCreateUnityContract } from 'src/controllers/UnityContracts/CreateUnityContractController';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useListUnityContractsController } from 'src/controllers/UnityContracts/ListUnityContractsController';
import { SyncLoader } from 'react-spinners';
import { ModelOfContractBidding, ModelOfContractBiddingItem } from 'src/database';
import { dateToString } from 'src/utils/dateToString';
import { Toast } from 'primereact/toast';
import { useListContractItemsController } from 'src/controllers/ContractItems/ListContractItemsController';
import { Dialog } from 'primereact/dialog';
import { useFormCreateContractItem } from 'src/controllers/ContractItems/CreateContractItemController';
import { Dropdown } from 'primereact/dropdown';
import { useFormCreateProducts } from 'src/controllers/Products/CreateProductsController';

interface filteredProps {
  label: string;
  value?: string;
};

const UnityContractForm: React.FC = () => {
  const { userAgencyName } = useAuth();
  const {
    currentBidding, selectedBudgetUnit, selectedContractBidding,
    setSelectedBudgetUnit, handleContractBidding, setSelectedContractBidding
  } = useData();
  const { getController } = useFormCreateProducts();
  const { getCreditorListController } = useListCreditorsController();
  const { getContractController } = useFormCreateUnityContract();
  const { getListUnityContracts, handleListUnityContractController } = useListUnityContractsController();
  const { getFormContractItem, handleFormContractItem } = useFormCreateContractItem();
  const { getListContratcItems, handleListContractItems } = useListContractItemsController();

  const [valueCreditors, setValueCreditors] = useState('');
  const [filteredCreditors, setFilteredCreditors] = useState<filteredProps[]>([{ label: '', value: '' }]);

  const history = useHistory();

  useMemo(() => {
    if (!!selectedContractBidding) {
      getContractController.formikContractBidding.setValues(selectedContractBidding);
      setValueCreditors(selectedContractBidding.DESCRICAO_CREDOR || '');
    }
  }, [selectedContractBidding?.ID])

  const creditors = getCreditorListController.CreditorsData.map((creditor) => {
    return { label: creditor.NOME, value: creditor.ID };
  });
  const brands = getController.tablesData.brandsData.map((brand) => {
    return { label: brand.DESCRICAO, value: brand.ID }
  }
  );
  const itemUnits = getFormContractItem.unitsData.map((unit) => {
    return { label: unit.DESCRICAO, value: unit.ID }
  }
  );

  const searchCreditors = (event: any) => {
    let filteredCreditors;
    if (!event.query.trim().length) {
      filteredCreditors = [...creditors];
    }
    else {
      filteredCreditors = creditors.filter((Creditors) => {
        return Creditors.label.toLowerCase().includes(event.query.toLowerCase());
      });
    }
    setFilteredCreditors(filteredCreditors);
  }

  const HEADER_NUMERO = (rowData: ModelOfContractBidding) => {
    return (
      <React.Fragment>
        <span className="left-header">NúMERO CONTRATO</span>
        {rowData.NUMERO}
      </React.Fragment>
    );
  }
  const HEADER_CREDOR = (rowData: ModelOfContractBidding) => {
    return (
      <React.Fragment>
        <span className="left-header">CREDOR</span>
        {rowData.DESCRICAO_CREDOR}
      </React.Fragment>
    );
  }
  const HEADER_DATAASSINATURA = (rowData: ModelOfContractBidding) => {
    return (
      <React.Fragment>
        <span className="left-header">DATA ASSINATURA</span>
        {dateToString(rowData.DATAASSINATURA, 'br')}
      </React.Fragment>
    );
  }
  const HEADER_VALOR = (rowData: ModelOfContractBidding) => {
    return (
      <React.Fragment>
        <span className="left-header">VALOR</span>
        {Intl.NumberFormat('pt-BR', {
          style: 'currency', currency: 'BRL'
        }).format(rowData?.VALOR || 0)}
      </React.Fragment>
    );
  }
  const HEADER_TOTALITEM = (rowData: ModelOfContractBidding) => {
    return (
      <React.Fragment>
        <span className="left-header">TOTAL ITEM</span>
        {Intl.NumberFormat('pt-BR', {
          style: 'currency', currency: 'BRL'
        }).format(rowData?.TOTALITEM || 0)}
      </React.Fragment>
    );
  }
  const HEADER_TOTALADITIVADO = (rowData: ModelOfContractBidding) => {
    return (
      <React.Fragment>
        <span className="left-header">TOTAL ADITIVADO</span>
        {Intl.NumberFormat('pt-BR', {
          style: 'currency', currency: 'BRL'
        }).format(rowData?.TOTALADITIVADO || 0)}
      </React.Fragment>
    );
  }


  const HEADER_DESCRICAO = (rowData: ModelOfContractBiddingItem) => {
    return (
      <React.Fragment>
        <span className="left-header">DESCRIÇÃO</span>
        {rowData?.DESCRICAO}
      </React.Fragment>
    );
  }
  const HEADER_UNIDADE = (rowData: ModelOfContractBiddingItem) => {
    return (
      <React.Fragment>
        <span className="left-header">UNIDADE</span>
        {rowData?.DESCRICAO_UNIDADE}
      </React.Fragment>
    );
  }
  const HEADER_MARCA = (rowData: ModelOfContractBiddingItem) => {
    return (
      <React.Fragment>
        <span className="left-header">MARCA</span>
        {rowData?.DESCRICAO_MARCA}
      </React.Fragment>
    );
  }
  const HEADER_QUANTIDADEREAL = (rowData: ModelOfContractBiddingItem) => {
    return (
      <React.Fragment>
        <span className="left-header">QUANTIDADE REAL</span>
        {rowData?.QUANTIDADEREAL}
      </React.Fragment>
    );
  }
  const HEADER_QUANTIDADE = (rowData: ModelOfContractBiddingItem) => {
    return (
      <React.Fragment>
        <span className="left-header">QUANTIDADE</span>
        {rowData?.QUANTIDADE}
      </React.Fragment>
    );
  }
  const HEADER_VALORITEM = (rowData: ModelOfContractBiddingItem) => {
    return (
      <React.Fragment>
        <span className="left-header">VALOR</span>
        {Intl.NumberFormat('pt-BR', {
          style: 'currency', currency: 'BRL'
        }).format(rowData?.VALOR || 0)}
      </React.Fragment>
    );
  }
  // const HEADER_TOTAL = (rowData: ModelOfContractBiddingItem) => {
  //   return (
  //     <React.Fragment>
  //       <span className="left-header">TOTAL</span>
  //       {Intl.NumberFormat('pt-BR', {
  //         style: 'currency', currency: 'BRL'
  //       }).format(rowData?.VALOR * rowData.QUANTIDADEREAL || 0)}
  //     </React.Fragment>
  //   );
  // }

  const contractItemFooter = (
    <React.Fragment>
      <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleFormContractItem.closeDialog} />
      <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getFormContractItem.formik.handleSubmit() }} />
    </React.Fragment>
  );

  const deleteBiddingContractDialogFooter = (
    <React.Fragment>
      <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleListUnityContractController.closeBiddingContractRemoveDialog} />
      <Button label="Sim" icon="pi pi-check" className="p-button-text"
        onClick={() => {
          getListUnityContracts.removableBiddingContract && handleListUnityContractController.removeContractBiddings(getListUnityContracts.removableBiddingContract)
        }}
      />
    </React.Fragment>
  );

  const deleteBiddingContractItemDialogFooter = (
    <React.Fragment>
      <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleListContractItems.closeBiddingContractItemRemoveDialog} />
      <Button label="Sim" icon="pi pi-check" className="p-button-text"
        onClick={() => {
          getListContratcItems.removableBiddingContractItem && handleListContractItems.removeContractItem(getListContratcItems.removableBiddingContractItem)
        }}
      />
    </React.Fragment>
  );

  const actionBodyTemplateContract = (contract: ModelOfContractBidding) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger"
          onClick={() => handleListUnityContractController.openBiddingContractRemoveDialog(contract)}
        />
      </React.Fragment>
    );
  };

  const actionBodyTemplateItem = (contractItem: ModelOfContractBiddingItem) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger"
          onClick={() => handleListContractItems.removeContractItem(contractItem)}
        />
      </React.Fragment>
    );
  };

  return (
    <div className="p-fluid p-grid">
      {getContractController.loading ? <LoadingScreen color="#0388e5" /> : <></>}
      <Toast ref={getContractController.toast} />
      <Toast ref={getFormContractItem.toast} />
      <Toast ref={getListUnityContracts.toast} />
      <Toast ref={getListContratcItems.toast} />
      <div className="p-col-12 p-md-6">
        <div style={{ height: '100%' }} className="p-fluid card p-align-center p-justify-center" >
          <h5>{selectedContractBidding?.ID ? 'Edição de Contrato' : 'Cadastro de Contrato'}</h5>
          <div className="p-fluid p-grid" >
            <Panel header={`Órgão: ${userAgencyName}`} >
              <div className="p-fluid p-field p-grid">
                <div className="p-col-12 p-md-6">
                  <span style={{ fontWeight: 800, textOverflow: 'ellipsis' }} >Unidade Orçamentária</span>
                </div>
                <div className="p-col-12 p-md-6">
                  <span>{selectedBudgetUnit?.NOME_ORGAOUNIDADE}</span>
                </div>
              </div>
              <div className="p-fluid p-field p-grid">
                <div className="p-col-12 p-md-6">
                  <span style={{ fontWeight: 800, textOverflow: 'ellipsis' }}>Licitação</span>
                </div>
                <div className="p-col-12 p-md-6">
                  <span>{currentBidding?.NUMEROLICITACAO}</span>
                </div>
              </div>
              <div className="p-fluid p-field p-grid">
                <div className="p-col-12 p-md-6">
                  <span style={{ fontWeight: 800, textOverflow: 'ellipsis' }}>Valor Global Licitação</span>
                </div>
                <div className="p-col-12 p-md-6">
                  <span>{Intl.NumberFormat('pt-BR', {
                    style: 'currency', currency: 'BRL'
                  }).format(currentBidding?.VALORGLOBAL || 0)}</span>
                </div>
              </div>
              <div className="p-fluid p-field p-grid">
                <div className="p-col-12 p-md-6">
                  <span style={{ fontWeight: 800, textOverflow: 'ellipsis' }}>Total Contratado Licitação</span>
                </div>
                <div className="p-col-12 p-md-6">
                  <span>{Intl.NumberFormat('pt-BR', {
                    style: 'currency', currency: 'BRL'
                  }).format(currentBidding?.TOTALCONTRATADO || 0)}</span>
                </div>
              </div>
              <div className="p-fluid p-grid">
                <div className="p-col-12 p-md-6">
                  <span style={{ fontWeight: 800, textOverflow: 'ellipsis' }}>Total Contratado Unidade</span>
                </div>
                <div className="p-col-12 p-md-6">
                  <span>{Intl.NumberFormat('pt-BR', {
                    style: 'currency', currency: 'BRL'
                  }).format(selectedBudgetUnit?.TOTALCONTRATADO || 0)}</span>
                </div>
              </div>
            </Panel>

            <div className="p-field p-col-12">
              <label htmlFor="contratado" >Contratado</label>
              <AutoComplete id="contratado"
                value={valueCreditors}
                field="label" placeholder="Buscar..."
                onChange={(e) => {
                  setValueCreditors(e.value)
                  getContractController.formikContractBidding.setFieldValue('CREDOR', filteredCreditors.find((Creditors) => {
                    return e.value === Creditors.label
                  })?.value || '')
                }}
                onSelect={(e) => {
                  setValueCreditors(e.value.label)
                  getContractController.formikContractBidding.setFieldValue('CREDOR', e.value.value)
                }}
                dropdown
                suggestions={filteredCreditors} completeMethod={searchCreditors}
              />
              <div className={classNames("p-invalid popup-fade", {
                'popup-form-active': getContractController.formikContractBidding.touched.CREDOR && getContractController.formikContractBidding.errors.CREDOR,
                'popup-form-inactive': !(getContractController.formikContractBidding.touched.CREDOR && getContractController.formikContractBidding.errors.CREDOR),
              })}
              >
                {getContractController.formikContractBidding.errors.CREDOR}
              </div>
            </div>

            <div className="p-field p-col-12 p-md-6">
              <label htmlFor="numeroContrato" >Número contrato</label>
              <InputText id="numeroContrato"
                {...getContractController.formikContractBidding.getFieldProps('NUMERO')}
                onChange={getContractController.formikContractBidding.handleChange('NUMERO')}
              />
              <div className={classNames("p-invalid popup-fade", {
                'popup-form-active': getContractController.formikContractBidding.touched.NUMERO && getContractController.formikContractBidding.errors.NUMERO,
                'popup-form-inactive': !(getContractController.formikContractBidding.touched.NUMERO && getContractController.formikContractBidding.errors.NUMERO),
              })}
              >
                {getContractController.formikContractBidding.errors.NUMERO}
              </div>
            </div>

            <div className="p-field p-col-12 p-md-6">
              <label htmlFor="dataAssinatura" >Data Assinatura</label>
              <InputMask id="dataAssinatura" mask="99/99/9999" placeholder='__/__/____'
                {...getContractController.formikContractBidding.getFieldProps('DATAASSINATURA')}
                onChange={(e) => getContractController.formikContractBidding.setFieldValue('DATAASSINATURA', e.value)}
              />
              <div className={classNames("p-invalid popup-fade", {
                'popup-form-active': getContractController.formikContractBidding.touched.DATAASSINATURA && getContractController.formikContractBidding.errors.DATAASSINATURA,
                'popup-form-inactive': !(getContractController.formikContractBidding.touched.DATAASSINATURA && getContractController.formikContractBidding.errors.DATAASSINATURA),
              })}
              >
                {getContractController.formikContractBidding.errors.DATAASSINATURA}
              </div>
            </div>

            <div className="p-field p-col-12 p-md-6">
              <label htmlFor="valorContrato" >Valor Contrato</label>
              <InputNumber id="valorContrato" mode="currency" currency="BRL" locale="pt-BR"
                {...getContractController.formikContractBidding.getFieldProps('VALOR')}
                onChange={(e) => getContractController.formikContractBidding.setFieldValue('VALOR', e.value)}
              />
              <div className={classNames("p-invalid popup-fade", {
                'popup-form-active': getContractController.formikContractBidding.touched.VALOR && getContractController.formikContractBidding.errors.VALOR,
                'popup-form-inactive': !(getContractController.formikContractBidding.touched.VALOR && getContractController.formikContractBidding.errors.VALOR),
              })}
              >
                {getContractController.formikContractBidding.errors.VALOR}
              </div>
            </div>

            <div className="p-field p-col-12 p-md-6">
              <label htmlFor="valorAditivado" >Valor Aditivado</label>
              <InputNumber id="valorAditivado" mode="currency" currency="BRL" locale="pt-BR"
                {...getContractController.formikContractBidding.getFieldProps('TOTALADITIVADO')}
                onChange={(e) => getContractController.formikContractBidding.setFieldValue('TOTALADITIVADO', e.value)}
              />
              <div className={classNames("p-invalid popup-fade", {
                'popup-form-active': getContractController.formikContractBidding.touched.TOTALADITIVADO && getContractController.formikContractBidding.errors.TOTALADITIVADO,
                'popup-form-inactive': !(getContractController.formikContractBidding.touched.TOTALADITIVADO && getContractController.formikContractBidding.errors.TOTALADITIVADO),
              })}
              >
                {getContractController.formikContractBidding.errors.TOTALADITIVADO}
              </div>
            </div>

            <div className="p-field p-col-12">
              <label htmlFor="observacao" >Observação</label>
              <InputTextarea id="observacao" rows={6} autoResize
                {...getContractController.formikContractBidding.getFieldProps('OBSERVACAO')}
                onChange={getContractController.formikContractBidding.handleChange('OBSERVACAO')}
              />
              <div className={classNames("p-invalid popup-fade", {
                'popup-form-active': getContractController.formikContractBidding.touched.OBSERVACAO && getContractController.formikContractBidding.errors.OBSERVACAO,
                'popup-form-inactive': !(getContractController.formikContractBidding.touched.OBSERVACAO && getContractController.formikContractBidding.errors.OBSERVACAO),
              })}
              >
                {getContractController.formikContractBidding.errors.OBSERVACAO}
              </div>
            </div>
          </div>

          <div className="p-fluid p-grid p-justify-between">
            <div className="p-col-12 p-md-4">
              <Button
                type="button"
                label={selectedContractBidding?.ID ? "Gravar alterações" : "Cadastrar"}
                onClick={() => {
                  getContractController.formikContractBidding.handleSubmit()
                }}
              />
            </div>
            {selectedContractBidding?.ID ?
              <div className="p-col-12 p-md-4">
                <Button
                  type="button"
                  className="p-button-success"
                  label="+ Cadastrar novo"
                  onClick={() => {
                    getContractController.formikContractBidding.resetForm();
                    setValueCreditors('');
                    sessionStorage.removeItem('@selectedContractBidding');
                    setSelectedContractBidding(null);
                  }}
                />
              </div>
              :
              <></>
            }
            <div className="p-col-12 p-md-4">
              <Button
                onClick={() => {
                  history.push('/biddingForm');
                  sessionStorage.removeItem('@selectedBudgetUnit');
                  setSelectedBudgetUnit(null);
                  sessionStorage.removeItem('@selectedContractBidding');
                  setSelectedContractBidding(null);
                }}
                type="button"
                label="Voltar"
                className="p-button-secondary"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="p-col-12 p-md-6" style={{ maxHeight: '90vh' }}>
        <div className="p-fluid card p-align-center p-justify-center" >
          <h5>Contratos registrados</h5>
          <div className="p-field">
            <DataTable value={getListUnityContracts.biddingContracts}
              className="p-datatable-sm p-datatable-clickable" dataKey="ORGAOUNIDADE"
              scrollable scrollHeight="100%"
              rowHover autoLayout
              onRowClick={(row) => {
                handleContractBidding({ ...row.data, DATAASSINATURA: dateToString(row.data.DATAASSINATURA, 'br') })
              }}
            >
              <Column field="NUMERO" header="NÚMERO CONTRATO" body={HEADER_NUMERO} />
              <Column field="DESCRICAO_CREDOR" header="CONTRATADO" body={HEADER_CREDOR} />
              <Column field="DATAASSINATURA" header="DATA ASSINATURA" body={HEADER_DATAASSINATURA} />
              <Column field="VALOR" header="VALOR DO CONTRATO" body={HEADER_VALOR} />
              <Column field="TOTALITEM" header="TOTAL ITEM" body={HEADER_TOTALITEM} />
              <Column field="TOTALADITIVADO" header="VALOR DO ADITIVO" body={HEADER_TOTALADITIVADO} />
              <Column body={actionBodyTemplateContract} bodyStyle={{ textAlign: 'right' }} />
            </DataTable>
            {getListUnityContracts.loading ?
              <div className='p-d-flex p-jc-center p-ai-center p-mt-3 p-mb-3'>
                <SyncLoader color="#0388e5" size={8} />
              </div>
              :
              <></>
            }
          </div>
        </div>

        <div className="p-fluid card p-align-center p-justify-center" >
          <h5>Itens do Contrato</h5>
          <div className="p-field">
            <DataTable value={getListContratcItems.contractItemsData}
              className="p-datatable-sm p-datatable-clickable" dataKey="ORGAOUNIDADE"
              scrollable scrollHeight="100%" rowHover autoLayout
              onRowClick={(row) => {
                handleFormContractItem.openDialogEdit(row.data);
              }}
            >
              <Column body={HEADER_DESCRICAO} field="DESCRICAO" header="DESCRIÇÃO" />
              <Column body={HEADER_UNIDADE} field="UNIDADE" header="UNIDADE" />
              <Column body={HEADER_MARCA} field="MARCA" header="MARCA" />
              <Column body={HEADER_QUANTIDADEREAL} field="QUANTIDADEREAL" header="QUANTIDADE REAL" />
              <Column body={HEADER_QUANTIDADE} field="QUANTIDADE" header="QUANTIDADE" />
              <Column body={HEADER_VALORITEM} field="VALOR" header="VALOR" />
              {/* <Column body={HEADER_TOTAL} field="TOTAL" header="TOTAL" /> */}
              <Column body={actionBodyTemplateItem} bodyStyle={{ textAlign: 'right' }} />
            </DataTable>
            {getListContratcItems.loading ?
              <div className='p-d-flex p-jc-center p-ai-center p-mt-3 p-mb-3'>
                <SyncLoader color="#0388e5" size={8} />
              </div>
              :
              <></>
            }
          </div>

          <div className="p-field p-grid">
            <div className="p-field p-col-12 ">
              <Button label="Adicionar item"
                type="button"
                onClick={() => { handleFormContractItem.openDialogForm() }}
              />
            </div>
          </div>

          <Dialog
            style={{ width: '60%' }} contentStyle={{ height: '100%' }}
            visible={getFormContractItem.formDialog || getFormContractItem.editDialog}
            onHide={handleFormContractItem.closeDialog}
            onShow={() => {
              getFormContractItem.formik.setValues(getFormContractItem.selectedItem);              
            }}
            header={getFormContractItem.formDialog? 'Cadastrar item de contrato / licitação' : 'Editar item de contrato / licitação' } dismissableMask
            modal footer={contractItemFooter} className="dropdown-visible"
          >
            {getFormContractItem.loading ? <LoadingScreen color="#0388e5" /> : <></>}
            <div className="p-grid p-fluid">
              <div className="p-field p-col-12">
                <label htmlFor="description">Descrição</label>
                <InputTextarea id="description" rows={6} autoResize
                  value={getFormContractItem.formik.values.DESCRICAO}
                  onChange={getFormContractItem.formik.handleChange('DESCRICAO')}
                />
                <div className={classNames("p-invalid popup-fade", {
                  'popup-form-active': getFormContractItem.formik.touched.DESCRICAO && getFormContractItem.formik.errors.DESCRICAO,
                  'popup-form-inactive': !(getFormContractItem.formik.touched.DESCRICAO && getFormContractItem.formik.errors.DESCRICAO),
                })}
                >{getFormContractItem.formik.errors.DESCRICAO}</div>
              </div>

              <div className="p-field p-col-12 p-md-6">
                <label htmlFor="unidade" >Unidade</label>
                <Dropdown id="unidade" placeholder="Selecionar..."
                  value={getFormContractItem.formik.values.UNIDADE}
                  onChange={(e) => {
                    getFormContractItem.formik.setFieldValue('UNIDADE', e.value)
                  }}
                  options={itemUnits}
                />
                <div className={classNames("p-invalid popup-fade", {
                  'popup-form-active': getFormContractItem.formik.touched.UNIDADE && getFormContractItem.formik.errors.UNIDADE,
                  'popup-form-inactive': !(getFormContractItem.formik.touched.UNIDADE && getFormContractItem.formik.errors.UNIDADE),
                })}
                >{getFormContractItem.formik.errors.UNIDADE}</div>
              </div>

              <div className="p-field p-col-12 p-md-6">
                <label htmlFor="marca" >Marca</label>
                <Dropdown id="marca" placeholder="Selecionar..."
                  value={getFormContractItem.formik.values.MARCA}
                  onChange={(e) => {
                    getFormContractItem.formik.setFieldValue('MARCA', e.value)
                  }}
                  options={brands}
                />
                <div className={classNames("p-invalid popup-fade", {
                  'popup-form-active': getFormContractItem.formik.touched.MARCA && getFormContractItem.formik.errors.MARCA,
                  'popup-form-inactive': !(getFormContractItem.formik.touched.MARCA && getFormContractItem.formik.errors.MARCA),
                })}
                >{getFormContractItem.formik.errors.MARCA}</div>
              </div>

              <div className="p-field p-col-12 p-md-4">
                <label htmlFor="quantidade">Quantidade real</label>
                <InputNumber id="quantidade" type="text"
                  value={getFormContractItem.formik.values.QUANTIDADEREAL}
                  onChange={(e) => getFormContractItem.formik.setFieldValue('QUANTIDADEREAL', e.value)}
                />
                <div className={classNames("p-invalid popup-fade", {
                  'popup-form-active': getFormContractItem.formik.touched.QUANTIDADEREAL && getFormContractItem.formik.errors.QUANTIDADEREAL,
                  'popup-form-inactive': !(getFormContractItem.formik.touched.QUANTIDADEREAL && getFormContractItem.formik.errors.QUANTIDADEREAL),
                })}
                >{getFormContractItem.formik.errors.QUANTIDADEREAL}</div>
              </div>

              <div className="p-field p-col-12 p-md-4">
                <label htmlFor="quantidade">Quantidade</label>
                <InputNumber id="quantidade" type="text"
                  value={getFormContractItem.formik.values.QUANTIDADE}
                  onChange={(e) => getFormContractItem.formik.setFieldValue('QUANTIDADE', e.value)}
                />
                <div className={classNames("p-invalid popup-fade", {
                  'popup-form-active': getFormContractItem.formik.touched.QUANTIDADE && getFormContractItem.formik.errors.QUANTIDADE,
                  'popup-form-inactive': !(getFormContractItem.formik.touched.QUANTIDADE && getFormContractItem.formik.errors.QUANTIDADE),
                })}
                >{getFormContractItem.formik.errors.QUANTIDADE}</div>
              </div>

              <div className="p-field p-col-12 p-md-4">
                <label htmlFor="valor">Valor</label>
                <InputNumber id="valor"
                  {...getFormContractItem.formik.getFieldProps('VALOR')}
                  onChange={(e) => getFormContractItem.formik.setFieldValue('VALOR', e.value)}
                  mode="currency" currency="BRL" locale="pt-BR"
                />
                <div className={classNames("p-invalid popup-fade", {
                  'popup-form-active': getFormContractItem.formik.touched.VALOR && getFormContractItem.formik.errors.VALOR,
                  'popup-form-inactive': !(getFormContractItem.formik.touched.VALOR && getFormContractItem.formik.errors.VALOR),
                })}
                >
                  {getFormContractItem.formik.errors.VALOR}
                </div>
              </div>
            </div>
          </Dialog>

          <Dialog
            style={{ width: '450px' }}
            visible={getListUnityContracts.biddingContractRemoveDialog}
            onHide={handleListUnityContractController.closeBiddingContractRemoveDialog}
            footer={deleteBiddingContractDialogFooter}
            header="Remover contrato"
            modal
          >
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {getListUnityContracts.removableBiddingContract && <span>Você tem certeza que deseja remover o contrato <b>{getListUnityContracts.removableBiddingContract.NUMERO}</b>?</span>}
            </div>
          </Dialog>

          <Dialog
            style={{ width: '450px' }}
            visible={getListContratcItems.biddingContractItemRemoveDialog}
            onHide={handleListContractItems.closeBiddingContractItemRemoveDialog}
            footer={deleteBiddingContractItemDialogFooter}
            header="Remover item"
            modal
          >
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {getListContratcItems.removableBiddingContractItem && <span>Você tem certeza que deseja remover o item <b>{getListContratcItems.removableBiddingContractItem.DESCRICAO}</b>?</span>}
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
};

export default UnityContractForm;